export default "__VITE_ASSET__z5qt83RH__"